import {createRuntimePaths} from './option/runtime';
import {
    createExternalRoutePath,
    createRoutePathGroup,
    createRoutePath,
    isExternalPath,
} from './option/routes';
import {createResources} from './option/resources';

class Option {
    constructor() {
        const {
            apiPath,
            contextPath,
            resourcePath,
        } = createRuntimePaths();

        this._apiPath = apiPath;
        this._contextPath = contextPath;
        this._resourcePath = resourcePath;
        this._routePath = createRoutePath(this._contextPath);
        this._routePathExternal = createExternalRoutePath(this._routePath);
        this._routePathGroup = createRoutePathGroup(this._routePath);
        this._resources = createResources({resourcePath: this._resourcePath});

        if (typeof window !== 'undefined') {
            window.option = this;
        }
    }

    get API_PATH() {
        return this._apiPath;
    }

    get CONTEXT_PATH() {
        return this._contextPath;
    }

    get RESOURCE_PATH() {
        return this._resourcePath;
    }

    /** @returns {ReturnType<typeof createRoutePath>} */
    get ROUTE_PATH() {
        return this._routePath;
    }

    get ROUTE_PATH_GROUP() {
        return this._routePathGroup;
    }

    get ROUTE_PATH_EXTERNAL() {
        return this._routePathExternal;
    }

    get INTO_IMAGE() {
        return this._resources.IMAGES;
    }

    isExternalPath(pathname) {
        return isExternalPath(this._routePathExternal, pathname);
    }
}

const OptionSingleton = (() => {
    let instance = null;
    return {
        getInstance: function () {
            if (!instance) {
                instance = new Option();
            }
            return instance;
        },
    };
})();

export default OptionSingleton.getInstance();
